import React, { useState, useEffect } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { supabase } from "../../lib/supabase";

const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("verifying"); // 'verifying', 'success', 'error'
  const [message, setMessage] = useState(
    "Verifying your email, please wait..."
  );
  const navigate = useNavigate();

  useEffect(() => {
    const verifyToken = async () => {
      const token = searchParams.get("token");
      if (!token) {
        setStatus("error");
        setMessage(
          "No verification token found. Please check the link and try again."
        );
        return;
      }

      try {
        const { error } = await supabase.functions.invoke(
          "confirm-verification",
          {
            body: { token },
          }
        );

        if (error) {
          throw new Error(
            error.message ||
              "Verification failed. The link may be invalid or expired."
          );
        }

        setStatus("success");
        setMessage(
          "Thank you! Your email has been successfully verified. You will be redirected shortly..."
        );

        // Redirect to the thank you page after 3 seconds
        setTimeout(() => {
          navigate("/join-us?form=thankyou");
        }, 1000);
      } catch (err) {
        setStatus("error");
        setMessage(err.message);
      }
    };

    verifyToken();
  }, [searchParams]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 font-inter p-6">
      <div className="w-full max-w-md text-center bg-white p-8 rounded-lg shadow-lg">
        {status === "verifying" && (
          <div className="flex justify-center items-center mb-4">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#5379F6]"></div>
          </div>
        )}
        {status === "success" && (
          <div className="text-green-500 text-5xl mb-4">✓</div>
        )}
        {status === "error" && (
          <div className="text-red-500 text-5xl mb-4">✗</div>
        )}
        <h1 className="text-2xl font-bold mb-4">Email Verification</h1>
        <p className="text-lg text-gray-600">{message}</p>
        {status === "error" && (
          <Link
            to="/"
            className="mt-8 inline-block bg-[#5379F6] hover:bg-[#4A6ACB] text-white font-semibold py-3 px-8 rounded-lg transition-colors duration-150"
          >
            Back to Home
          </Link>
        )}
      </div>
    </div>
  );
};

export default VerifyEmailPage;
